<div class="backoffice">

  <div
    class="sidebar-overlay"
    *ngIf="menuAberto"
    (click)="fecharMenu()">
  </div>

  <aside class="sidebar" [class.sidebar-open]="menuAberto">

    <div class="sidebar-header">
      <a
        class="brand"
        [routerLink]="isAdmin ? '/admin/dashboard' : '/parceiro/dashboard'"
        (click)="fecharMenu()">

        <span class="brand-icon">C</span>

        <span class="brand-text">
          <strong>CuidaZap</strong>
          <small>Backoffice</small>
        </span>
      </a>

      <button
        class="mobile-close"
        type="button"
        aria-label="Fechar menu"
        (click)="fecharMenu()">
        ✕
      </button>
    </div>

    <div class="sidebar-content">

      <div class="menu-label">MENU PRINCIPAL</div>

      <nav class="nav-menu" aria-label="Navegação principal">

        <ng-container *ngIf="isAdmin; else menuParceiro">

          <a
            routerLink="/admin/dashboard"
            routerLinkActive="active"
            (click)="fecharMenu()">
            <span class="nav-icon">
<svg xmlns="http://www.w3.org/2000/svg"
     width="22" height="22"
     viewBox="0 0 24 24"
     fill="none"
     stroke="currentColor"
     stroke-width="1.8"
     stroke-linecap="round"
     stroke-linejoin="round"
     aria-hidden="true">
  <rect x="3" y="3" width="7" height="9" rx="1.5"/>
  <rect x="14" y="3" width="7" height="5" rx="1.5"/>
  <rect x="14" y="12" width="7" height="9" rx="1.5"/>
  <rect x="3" y="16" width="7" height="5" rx="1.5"/>
</svg>
</span>
            Dashboard
          </a>

          <a
            routerLink="/admin/assinaturas"
            routerLinkActive="active"
            (click)="fecharMenu()">
            <span class="nav-icon">
<svg xmlns="http://www.w3.org/2000/svg"
     width="22" height="22"
     viewBox="0 0 24 24"
     fill="none"
     stroke="currentColor"
     stroke-width="1.8"
     stroke-linecap="round"
     stroke-linejoin="round"
     aria-hidden="true">
  <rect x="2" y="5" width="20" height="14" rx="3"/>
  <path d="M2 10h20"/>
  <path d="M6 15h4"/>
  <path d="m16 14 2 2-2 2"/>
</svg>
</span>
            Assinaturas
          </a>

          <a
            routerLink="/admin/parceiros"
            routerLinkActive="active"
            (click)="fecharMenu()">
            <span class="nav-icon">
<svg xmlns="http://www.w3.org/2000/svg"
     width="22" height="22"
     viewBox="0 0 24 24"
     fill="none"
     stroke="currentColor"
     stroke-width="1.8"
     stroke-linecap="round"
     stroke-linejoin="round"
     aria-hidden="true">
  <path d="m2 12 4-4 4 2 3-2a2 2 0 0 1 2.4.2L22 14"/>
  <path d="m2 12 5 6a2 2 0 0 0 2.8.2l1.2-1"/>
  <path d="m10 15 3 3a2 2 0 0 0 2.8 0l.7-.7"/>
  <path d="m13 13 4 4a2 2 0 0 0 2.8 0"/>
  <path d="M2 8 5 5l3 2"/>
  <path d="m22 10-3-3-3 1"/>
</svg>
</span>
            Parceiros
          </a>

        </ng-container>

        <ng-template #menuParceiro>

          <a
            routerLink="/parceiro/dashboard"
            routerLinkActive="active"
            (click)="fecharMenu()">
            <span class="nav-icon"><svg xmlns="http://www.w3.org/2000/svg"
                                        width="22" height="22"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="1.8"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        aria-hidden="true">
  <rect x="3" y="3" width="7" height="9" rx="1.5"/>
  <rect x="14" y="3" width="7" height="5" rx="1.5"/>
  <rect x="14" y="12" width="7" height="9" rx="1.5"/>
  <rect x="3" y="16" width="7" height="5" rx="1.5"/>
</svg></span>
            Dashboard
          </a>

          <a
            routerLink="/parceiro/usuarios"
            routerLinkActive="active"
            (click)="fecharMenu()">
            <span class="nav-icon"><svg xmlns="http://www.w3.org/2000/svg"
                                        width="22" height="22"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="1.8"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        aria-hidden="true">
  <circle cx="12" cy="8" r="4"/>
  <path d="M5 21v-2a7 7 0 0 1 14 0v2"/>
</svg></span>
            Usuários
          </a>

          <!-- LEMBRETES -->
          <a
            routerLink="/parceiro/lembretes"
            routerLinkActive="active"
            (click)="fecharMenu()">

    <span class="nav-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true">

        <rect
          x="3"
          y="5"
          width="18"
          height="16"
          rx="2"/>

        <path d="M16 3v4"/>
        <path d="M8 3v4"/>
        <path d="M3 10h18"/>

        <path d="m9 16 2 2 4-4"/>

      </svg>
    </span>

            Lembretes
          </a>

        </ng-template>

      </nav>
    </div>

    <div class="sidebar-footer">
      <div class="user-card">
        <div class="avatar">{{ iniciais }}</div>

        <div class="user-details">
          <strong>{{ nomeUsuario }}</strong>
          <span>{{ isAdmin ? 'Administrador' : 'Parceiro' }}</span>
        </div>
      </div>

      <button class="logout-button" type="button" (click)="sair()">
        <span>↪</span>
        Sair da conta
      </button>
    </div>

  </aside>

  <div class="main-wrapper">

    <header class="topbar">

      <div class="topbar-left">
        <button
          class="menu-toggle"
          type="button"
          aria-label="Abrir menu"
          [attr.aria-expanded]="menuAberto"
          (click)="menuAberto = !menuAberto">
          ☰
        </button>

        <div class="breadcrumb">
          <span>CuidaZap</span>
          <span class="separator">/</span>
          <strong>{{ isAdmin ? 'Administração' : 'Área do parceiro' }}</strong>
        </div>
      </div>

      <div class="topbar-right">
        <span class="status-dot"></span>
        <span class="status-text">Painel de controle</span>
        <div class="topbar-avatar">{{ iniciais }}</div>
      </div>

    </header>

    <main class="page-content">
      <router-outlet></router-outlet>
    </main>

  </div>

</div>
